import axios from "axios";
import { BASE_URL } from "@constants/constants";
import { getItem } from "@helpers/helpers";
import { STORAGE_KEY } from "@constants/constants";

const axiosInstance = axios.create({
    baseURL: BASE_URL,
    headers:{
        'Content-Type': 'application/json',
    }
});

axiosInstance.interceptors.request.use(

    (config) => {      
      const token = getItem(STORAGE_KEY.TOKEN)      

      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
      }
      return config;
    },
    (error) => {
      // Handle request error
      return Promise.reject(error);
    }
  );

  axiosInstance.interceptors.response.use(
    (response) => {
      // Handle response data if needed
      return response;

    },
    (error) => {
      // Handle response error
      return Promise.reject(error);
    }
  );

  export default axiosInstance;
